<template>
	<!-- banner -->
	<section v-if="topoBanner != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- Politicas e termos -->
	<section>
		<div class="section">
			<div class="container pol-top">
				<div class="row heading-section">
					<div class="col-lg-3 col-md-6 col-sm-8 order-1 order-lg-1">
						<div class="filter-widget ">
							<h4 class="subheading nl-10">Informações</h4>
							<ul class="filter-catagories mn-produto">
								<li v-for="(menu, menuIndex) in informacoes" :key="menuIndex"><a href="#"
										@click.prevent="carregaTexto(menu.itiId)">{{ menu.itiNome }}</a></li>

							</ul>
						</div>

					</div>

					<!-- textos -->
					<div v-if="informacao != ''" class="col-lg-9 order-2 order-lg-2 pol-tex">
						<h2>{{ informacao[0].itiNome }}</h2><br>
						<p v-html="informacao[0].itiResumo1"> </p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END politicas e termos -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'
import { useRoute } from 'vue-router';

export default {
	name: 'InformacoesView',
	components: {
	},

	setup() {
		const route = useRoute();
		const id = route.params.id;
		const nome = route.params.nome;
		return {
			id,
			nome
		};
	},

	data: () => ({
		topoBanner: [],
		informacoes: [],
		informacao: [],
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Clientes - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},
		carregaTexto(value) {
			this.informacao = this.informacoes.filter(x => x.itiId == value)
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		this.carregaMetas("---");

		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/17/informacoesgeraistopo/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo Banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca os textos
		axios.get('/Process/InsInstitucional/institucional/18/informacoes/0/x')
			.then(response => {
				this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
				if (this.id) {
					this.carregaTexto(this.id);
				}
				else {
					this.carregaTexto(this.informacoes[0].itiId);
				}
			})
			.catch(error => {
				console.error(error);
			});


	},
}

</script>

<style scoped></style>
